

















import { Component, Vue } from "vue-property-decorator";
import { getters, mutations } from "@/observables";

@Component({})
export default class extends Vue {
  /* Data */
  default = { id: 0, descLocal: this.$t("common.all") } as TenderMixOperator.Warehouse;
  warehouse = this.default;

  /* Computed */
  get warehouses() {
    return [this.default, ...getters.getWarehouses()];
  }

  /* methods */
  onChange() {
    mutations.setWarehouseSelected(this.warehouse);
    this.$emit("change");
  }
}
